import React from 'react';
// import avatar from '../assets/avatar.png';
import ErrorElement from '../components/ErrorElement';

function ErrorPage() {
  return <ErrorElement />;
}

export default ErrorPage;
